import {Box, Button} from "@mui/material";

interface FileComponentProps {
	data: any;
	
}

export const FileComponent = ({data}: FileComponentProps) => {
	return (
		<Box sx={{
			position: 'relative',
			height: '478px',
			width: '100%',
			background: '#808992',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		}}>
			<Button
				variant="contained"
				color="primary"
				href={data.slides}
				sx={{
					background: '#fff',
					color: '#000',
					'&:hover': {
						background: '#d5d5d5',
						color: '#000',
					},
				}}
			
			>
				Скачать ресурсы</Button>
		</Box>
	)
}